export const subjects = ["Science", "Math", "Environmental Studies", "Biology", "Physics", "Chemistry", "Generic", "Political Science", "Economics", "History", "Civics", "Geography"];
